export const ANALYTICS_EVENT_FIRED = 'ANALYTICS_EVENT_FIRED'
export const ANALYTICS_EVENT_SENT = 'ANALYTICS_EVENT_SENT'
export const FACEBOOK_ANALYTICS_EVENT_SENT = 'FACEBOOK_ANALYTICS_EVENT_SENT'
